import { PLAN_TYPES } from "./plans";
import { getFeatureStatus } from "./utils";

const formatAiAssistantText = (entitlements, plan, t) => {
  const getEntitlement = (type) => entitlements?.find((e) => e.type === type);
  const e = getEntitlement("aiAssistant");

  if (plan === PLAN_TYPES.FAMILY) return t("unlimited");
  if (plan === PLAN_TYPES.PREMIUM) return `${e.limit} ${t("request")} / ${e.resetPeriodHours} ${t("hours")}`;
  if (plan === PLAN_TYPES.FREE) return e.limit ? `${String(e.limit)} ${t("request")}` : '';
};

export const createSubscriptionFeatures = ({ entitlements = [], plan, t, lang }) => {
  const getEntitlement = (type) => entitlements.find(item => item.type === type);

  const books = getEntitlement("books");
  const cartoons = getEntitlement("cartoons");
  const puzzles = getEntitlement("puzzles");
  const paintings = getEntitlement("paintings");
  const aiAssistant = getEntitlement("aiAssistant");
  const bedtime = getEntitlement("bedtime");
  const familySharing = getEntitlement("familySharing");
  const offlineMode = getEntitlement("offlineMode");

  const formatLimitText = (item, singularKey, pluralKey) => {
    if (!item?.limit || item.limit <= 0) return t(item?.title);

    const isSingle = lang === 'am' || item.limit === 1;

    return `${item.limit} ${t(isSingle ? singularKey : pluralKey)?.toLowerCase()}`;
  };

  return [
    {
      icon: books?.icon ?? "📚",
      text: formatLimitText(books, 'book', 'books'),
      status: getFeatureStatus(books?.access !== "NONE")
    },
    {
      icon: cartoons?.icon ?? "🎬",
      text: formatLimitText(cartoons, 'cartoon', 'cartoons'),
      status: getFeatureStatus(cartoons?.access !== "NONE")
    },
    {
      icon: puzzles?.icon ?? "🧩",
      text: formatLimitText(puzzles, 'puzzle', 'puzzles'),
      status: getFeatureStatus(puzzles?.access !== "NONE")
    },
    {
      icon: paintings?.icon ?? "🎨",
      text: formatLimitText(paintings, 'drawing_canvas', 'drawing_canvases'),
      status: getFeatureStatus(paintings?.access !== "NONE")
    },
    {
      icon: bedtime?.icon ?? "🌙",
      text: t(bedtime?.title),
      status: getFeatureStatus(bedtime?.access !== "NONE")
    },
    {
      icon: familySharing?.icon ?? "👪",
      text: t(familySharing?.title),
      status: getFeatureStatus(familySharing?.limit > 1 && bedtime?.access !== "NONE")
    },
    {
      icon: offlineMode?.icon ?? "👪",
      text: t('offline_use_in_the_mobile_app'),
      status: getFeatureStatus(offlineMode?.access !== "NONE")
    },
    {
      icon: aiAssistant?.icon ?? "🤖",
      text: t('ai_assistant'),
      status: getFeatureStatus(aiAssistant?.enabled),
      statusText: formatAiAssistantText(entitlements, plan, t),
    }
  ];
};